import { useState } from "react";
import { NavLink } from "react-router-dom";

import {
	Render_measurtement,
	Toggle_measurtement_type,
	Render_summary,
	Render_status,
	Render_save_overlay,
} from "../js/bay-checker.js";

export default function Recess_pole() {
	const [update, force_update] = useState(0);

	const [measurtement_ab, set_measurtement_ab] = useState("");

	let does_it_work = measurtement_ab > 5;
	let the_summary = "(empty)";

	return (
		<div className="bay max_width">
			<div className="top">
				<div className="header">
					<NavLink className="back_to_home" to="/app/bay-checker/"></NavLink>
					<h2>
						<strong>Recess</strong> Pole
					</h2>
				</div>

				<div className="svg_wrap">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 330 120">
						<path
							fill="#7BAABD"
							fillRule="evenodd"
							d="M56 43a4 4 0 0 1 4-4h210a4 4 0 0 1 4 4v22h52a4 4 0 0 1 0 8h-56a4 4 0 0 1-4-4V47H64v22a4 4 0 0 1-4 4H4a4 4 0 0 1 0-8h52V43Z"
							clipRule="evenodd"
						/>
						<path
							fill="#D4D0C4"
							fillRule="evenodd"
							d="M73.5 58c0-.8.7-1.5 1.5-1.5h3a1.5 1.5 0 0 1 0 3h-3c-.8 0-1.5-.7-1.5-1.5Zm9 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h6a1.5 1.5 0 0 1 0 3h-6c-.8 0-1.5-.7-1.5-1.5Zm12 0c0-.8.7-1.5 1.5-1.5h3a1.5 1.5 0 0 1 0 3h-3c-.8 0-1.5-.7-1.5-1.5Z"
							clipRule="evenodd"
						/>

						<g className="g_a">
							<path
								className="shape"
								d="M46 33a11 11 0 0 0 0 22h11V44c0-6-5-11-11-11Zm0-3a14 14 0 1 0 0 28h14V44a14 14 0 0 0-14-14Z"
							/>
							<path d="M44.3 37.2h2.5L51.5 50h-2.6l-1.2-3.2h-4.4L42 50h-2.6l4.8-12.8Zm3 7.9-1.8-5.3-1.8 5.3h3.6Z" />
						</g>
						<g className="g_b">
							<path
								className="shape"
								d="M284 33c-6 0-11 5-11 11v11h11a11 11 0 0 0 0-22Zm0-3a14 14 0 0 0-14 14v14h14a14 14 0 1 0 0-28Z"
							/>
							<path d="M289 46.7a3 3 0 0 1-.5 1.8c-.4.5-1 .9-1.6 1.1-.6.3-1.3.4-2 .4h-6.2V37.2h6.9c.6 0 1 .2 1.5.5a3.5 3.5 0 0 1 .9 4.5c-.3.6-.8 1-1.4 1.2a3.2 3.2 0 0 1 2.4 3.3Zm-2.5-.5c0-.3 0-.6-.2-.8a1 1 0 0 0-.5-.6c-.2-.2-.5-.3-.8-.3h-3.8V48h3.7c.3 0 .6 0 .8-.2a1.7 1.7 0 0 0 .8-1.5Zm-5.3-6.9v3.3h3.3l.8-.2.5-.6c.2-.2.2-.5.2-.9 0-.3 0-.6-.2-.8a1.3 1.3 0 0 0-1.2-.8h-3.4Z" />
						</g>
					</svg>
				</div>

				<Toggle_measurtement_type force_update={force_update} />
			</div>

			<div className="pusher" style={{ aspectRatio: "33 / 12" }}></div>

			<div className={does_it_work ? "the_measurements pass" : "the_measurements"}>
				<h4>Wall Measurements</h4>

				<div className="measurtement_wrapper">
					<Render_measurtement
						key="measurtement_ab"
						measurtement_name="ab"
						measurtement={measurtement_ab}
						set_measurtement={set_measurtement_ab}
						force_update={force_update}
					/>
				</div>

				<Render_status does_it_work={does_it_work} />

				{["ab"].map((key) => {
					let new_line = Render_summary({
						the_key: key,
						measurtement_mm: parseInt(eval("measurtement_" + key)),
					});
					if (the_summary == "(empty)") the_summary = new_line;
					else the_summary += new_line;

					//console.log(the_summary);
				})}

				<Render_save_overlay force_update={force_update} the_summary={the_summary} bay_type="Recess Pole" />
			</div>
		</div>
	);
}
